import * as React from 'react';

import { withStyles } from '@gdp/react-app/lib/helpers/withStyles';

interface GlairIconProps {
  icon?: 'Check' | 'Error' | 'Warning' | 'Copy' | 'CSV' | 'PDF';
}

@withStyles(require('./GlairIcon.scss'))
export class GlairIcon extends React.Component<GlairIconProps> {
  render() {
    if (this.props.icon) {
      switch (this.props.icon) {
        case 'Check':
          return <span className="GlairIcon GlairIcon--positive"></span>;
        case 'Error':
          return <span className="GlairIcon GlairIcon--negative"></span>;
        case 'Warning':
          return <span className="GlairIcon GlairIcon--warning"></span>;
        case 'Copy':
          return <span className="GlairIcon GlairIcon--neutral"></span>;
        case 'CSV':
          return <span className="GlairIcon GlairIcon--neutral"></span>;
        case 'PDF':
          return <span className="GlairIcon GlairIcon--neutral-inverse"></span>;
        default:
          return undefined;
      }
    }
    else {
      return (
        <span className="GlairIcon">
        {this.props.children}
      </span>
      );
    }
  }
}
